// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ILanguage } from 'src/types/language';
import { LanguageService } from 'src/services/language-service';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-language-selector',
    templateUrl: './language-selector.component.html',
    standalone: false
})
export class LanguageSelectorComponent {
  @Input() label = 'Select Language';
  @Input() selectedLanguage = 'en';
  @Input() disabled: boolean;
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  supportedLanguages: ILanguage[] = [{name: "English", code: "en"}];

  constructor(private languageService: LanguageService, translate: TranslateService) {
      this.disabled = false;
      translate.get(['SELECT_LANGUAGE_LABEL']).subscribe(vals => {
        this.label = vals['SELECT_LANGUAGE_LABEL'];
      });
      this.languageService.getSupportedLanguages()
          .pipe(untilDestroyed(this))
          .subscribe(res => this.supportedLanguages = res.supported_languages);
  }

  onLanguageSelectChanged(event) {
    this.selectedLanguage = event.value.toString();
    this.valueChange.emit(this.selectedLanguage);
  }

}
